// import React from "react";
// import {thunk} from 'redux-thunk';
// import { StrictMode } from 'react';
// import { reducers } from "./reducer";
// import { Provider } from 'react-redux'
// import ReactDOM from "react-dom/client";
// import App from "./App";
// import { BrowserRouter } from "react-router-dom";
// import { SidebarProvider } from "./pages/global/contexts/SidebarContext";
// import { applyMiddleware, legacy_createStore as createStore,compose  } from "redux";

// const store = createStore(reducers, {}, compose(applyMiddleware(thunk)))
// //StrictMode should be removed for the prod

// const root = ReactDOM.createRoot(document.getElementById("root"));
// root.render(
//   // <StrictMode>
//     <Provider store={store}>
//       <SidebarProvider>
//         <BrowserRouter>
//           <App />
//         </BrowserRouter>
//       </SidebarProvider>
//     </Provider>
//   // </StrictMode>
// );



import React from "react";
import { thunk } from 'redux-thunk';
import { Provider } from 'react-redux';
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import { applyMiddleware, legacy_createStore as createStore, compose } from "redux";
import { SidebarProvider } from "./pages/global/contexts/SidebarContext";
import { ThemeProvider } from "./context/themeContext";
import { reducers } from "./reducer";
import App from "./App";

const store = createStore(reducers, {}, compose(applyMiddleware(thunk)));

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <SidebarProvider>
      <ThemeProvider>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </ThemeProvider>
    </SidebarProvider>
  </Provider>
);